import React from 'react';
import { usePermissionContext } from 'contexts/PermissionContext';

/* Carrega e disponibiliza as permissões do usuário para um módulo específico */
export default function useModulePermissions(codmodulo) {
  const {
    codusuario,
    isTechnicalUser,
    loadPermissions,
    hasPerm,
    isLoading,
    permissionsByModule
  } = usePermissionContext();

  const lastLoadKeyRef = React.useRef('');

  React.useEffect(() => {
    if (!codusuario || !codmodulo) return;

    const moduleKey = String(codmodulo);
    const currentKey = `${codusuario}-${moduleKey}`;

    if (lastLoadKeyRef.current === currentKey) {
      return;
    }

    lastLoadKeyRef.current = currentKey;
    loadPermissions(codusuario, moduleKey, false); // só busca false na primeira vez, true busca sempre no db
  }, [codusuario, codmodulo, loadPermissions]);

  const moduleKey = codmodulo ? String(codmodulo) : null;
  const hasModuleLoaded = !!moduleKey && Object.prototype.hasOwnProperty.call(permissionsByModule, moduleKey);
  const permissions = moduleKey ? permissionsByModule[moduleKey] || [] : [];
  const loading = moduleKey ? (isLoading(moduleKey) || !hasModuleLoaded) : false;

  return {
    hasPerm: (permCode) => {
      if (!moduleKey) return true;

      return hasPerm(moduleKey, permCode);
    },
    loading,
    isTechnicalUser,
    permissions
  };
};